'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412 from "./presto.-Register-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$11() {
  this.bud = null;
  this.bu5 = null;
  this.bu6 = false;
  this.bue = null;
  this.buf = false;
  this.bui = null;
  this.bub = null;
  this.buc = false;
  this.bu7 = null;
  this.bu8 = false;
  this.bu9 = null;
  this.bua = false;
  this.bug = false;
  this.buh = false;
  this.bud = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bui = "CompactFeature";
}
export { $c_Lpresto_RegisterPageView$$anon$11 as $c_Lpresto_RegisterPageView$$anon$11 };
$p = $c_Lpresto_RegisterPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$11;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$11() {
}
export { $h_Lpresto_RegisterPageView$$anon$11 as $h_Lpresto_RegisterPageView$$anon$11 };
$h_Lpresto_RegisterPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bud;
});
$p.M = (function() {
  if ((!this.bu6)) {
    this.bu5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bu6 = true;
  }
  return this.bu5;
});
$p.O = (function() {
  if ((!this.buf)) {
    this.bue = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.buf = true;
  }
  return this.bue;
});
$p.D = (function() {
  return this.bui;
});
$p.t = (function() {
  if ((!this.buc)) {
    this.bub = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.buc = true;
  }
  return this.bub;
});
$p.N = (function() {
  if ((!this.bu8)) {
    this.bu7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().ae0(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bu8 = true;
  }
  return this.bu7;
});
$p.Q = (function() {
  if ((!this.bua)) {
    this.bu9 = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_RegisterPageView$$anon$12();
    this.bua = true;
  }
  return this.bu9;
});
$p.v = (function() {
  if ((!this.buh)) {
    this.bug = false;
    this.buh = true;
  }
  return this.bug;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee92) => ((p) => \u03b4scrutinee92.adE(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_RegisterPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$11, "presto.RegisterPageView$$anon$11", ({
  Q1: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$11 as $d_Lpresto_RegisterPageView$$anon$11 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$11.js.map
